/* ============================================================
   GYMSPIDERR — CUSTOM CURSOR
   Cursor personalizado tipo Lusion adaptado a la marca.
   Solo desktop. En mobile/touch se mantiene el cursor del sistema.
   ============================================================ */

(function () {
  'use strict';

  // No correr en mobile / touch / reduced motion
  var isTouch = ('ontouchstart' in window) || navigator.maxTouchPoints > 0;
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isSmallScreen = window.matchMedia('(max-width: 990px)').matches;

  if (isTouch || prefersReducedMotion || isSmallScreen) {
    return;
  }

  // Crear los dos elementos del cursor (dot y ring)
  var dot = document.createElement('div');
  dot.className = 'gym-cursor gym-cursor--dot';
  dot.setAttribute('aria-hidden', 'true');

  var ring = document.createElement('div');
  ring.className = 'gym-cursor gym-cursor--ring';
  ring.setAttribute('aria-hidden', 'true');

  // Insertar al body cuando esté listo
  function init() {
    document.body.appendChild(dot);
    document.body.appendChild(ring);
    document.documentElement.classList.add('gym-cursor-active');

    bindEvents();
  }

  // Posiciones target y current (suavizado)
  var mouseX = window.innerWidth / 2;
  var mouseY = window.innerHeight / 2;
  var ringX = mouseX;
  var ringY = mouseY;
  var dotX = mouseX;
  var dotY = mouseY;

  function onMove(e) {
    mouseX = e.clientX;
    mouseY = e.clientY;
  }

  function animate() {
    // dot sigue inmediato (suavizado mínimo)
    dotX += (mouseX - dotX) * 0.55;
    dotY += (mouseY - dotY) * 0.55;

    // ring sigue con delay para sensación premium
    ringX += (mouseX - ringX) * 0.18;
    ringY += (mouseY - ringY) * 0.18;

    dot.style.transform = 'translate3d(' + dotX + 'px, ' + dotY + 'px, 0)';
    ring.style.transform = 'translate3d(' + ringX + 'px, ' + ringY + 'px, 0)';

    requestAnimationFrame(animate);
  }

  // Detectar elementos clickeables y aplicar estado hover
  var hoverSelectors = [
    'a',
    'button',
    '[role="button"]',
    'input[type="submit"]',
    'input[type="button"]',
    'label',
    '.card-wrapper',
    '.collection-list__item',
    '.gym-lookbook__item',
    '.gym-ig-grid__item',
    '.slideshow__slide',
    '.product-card-wrapper',
    '[data-cursor-hover]'
  ].join(',');

  function bindEvents() {
    document.addEventListener('mousemove', onMove, { passive: true });

    // Click feedback
    document.addEventListener('mousedown', function () {
      document.documentElement.classList.add('gym-cursor-down');
    });
    document.addEventListener('mouseup', function () {
      document.documentElement.classList.remove('gym-cursor-down');
    });

    // Mouse fuera de la ventana
    document.addEventListener('mouseleave', function () {
      document.documentElement.classList.add('gym-cursor-hidden');
    });
    document.addEventListener('mouseenter', function () {
      document.documentElement.classList.remove('gym-cursor-hidden');
    });

    // Hover en clickeables (delegación + observer para nuevos elementos)
    document.addEventListener('mouseover', function (e) {
      if (e.target.closest(hoverSelectors)) {
        document.documentElement.classList.add('gym-cursor-hover');
      }
    });

    document.addEventListener('mouseout', function (e) {
      if (e.target.closest(hoverSelectors)) {
        document.documentElement.classList.remove('gym-cursor-hover');
      }
    });

    requestAnimationFrame(animate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
